import { defineComponent as _defineComponent } from 'vue'
import Modal from "../Modal.vue";
  import { computed, onMounted, ref, watch } from "vue";
  import EstateMap from "@/components/EstateMap.vue";
  import StageMap from "@/components/StageMap.vue";
  import StageList from "@/components/StageList.vue";
  import { UserRoles } from "@/enums/UserRoles";
  import { MapPages } from "@/enums/MapPages";
  import { LotMapInterface } from "@/types/LotMapInterface";
  import { LotInterface } from "@/types/LotInterface";
  import router from "@/router";
  import { useIsDesktop } from "@/features/useIsDesktop";
  import { EstateInterface } from "@/types/EstateInterface";
  import { LotStatus } from "@/enums/LotStatus";

  const smallLayoutWidth = 990;
  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderLotsMapModal',
  props: {
    isOpen: { type: Boolean },
    lotsByHouseDesigns: {},
    estateInfo: {}
  },
  emits: ["close", "back", "send"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;

  const props = __props;

  const viewType = ref<"list" | "map">("map");
  const viewTypeMap = ref<"estate" | "stage">("estate");
  const isEmbedded = ref(true);

  const { isDesktop } = useIsDesktop(smallLayoutWidth);

  const actualStageQuote = computed(() => {
    return props.lotsByHouseDesigns?.[0]?.stageId;
  });

  const onClose = () => {
    emits("close");
  };

  const onReserve = (lot: LotMapInterface) => {
    if (lot.lotId.status === LotStatus.AVAILABLE) {
      emits("send", lot);
    }
  };

  const toggleViewTypeMap = () => {
    viewTypeMap.value = viewTypeMap.value === "estate" ? "stage" : "estate";
  };

  watch(
    () => props.isOpen,
    (newVal) => {
      if (newVal) {
        viewTypeMap.value = isDesktop.value ? "estate" : "stage";
      }
    }
  );

const __returned__ = { emits, props, viewType, viewTypeMap, isEmbedded, smallLayoutWidth, isDesktop, actualStageQuote, onClose, onReserve, toggleViewTypeMap, Modal, computed, onMounted, ref, watch, EstateMap, StageMap, StageList, get UserRoles() { return UserRoles }, get MapPages() { return MapPages }, get LotMapInterface() { return LotMapInterface }, get LotInterface() { return LotInterface }, get router() { return router }, get useIsDesktop() { return useIsDesktop }, get EstateInterface() { return EstateInterface }, get LotStatus() { return LotStatus } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})